import { gql } from "@apollo/client";

export const listCountries = gql`
  query {
    listMetaCountrys {
      items {
        id
        name
        states {
          items {
            id
            name
          }
        }
      }
    }
  }
`;

export const listOnboardingVideos = gql`
  query listOnboardingVideos {
    getIntroductoryVideos {
      target {
        sequence
        title
        url
        key
      }
      checkin {
        sequence
        title
        url
        key
      }
      objective {
        sequence
        title
        url
        key
      }
    }
  }
`;
 export const getUnsplashImages =gql`
 query getUnsplashImages {
  getRandomUnsplashImages {
    unsplashImages {
      id
      url
      thumbnail
    }
  }
}`